import { render, staticRenderFns } from "./ComDetails.vue?vue&type=template&id=c283e400&scoped=true&"
import script from "./ComDetails.vue?vue&type=script&lang=js&"
export * from "./ComDetails.vue?vue&type=script&lang=js&"
import style0 from "./ComDetails.vue?vue&type=style&index=0&id=c283e400&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c283e400",
  null
  
)

export default component.exports